export const getManageCommissionFormKey = (commissionId?: string, offerId?: string) =>
    commissionId ?? offerId ?? "create";
